<div class="welcome-page">
    <section id="main-banner" class="one">
        <header class="header-1">
            <nav class="navbar active" id="slide-nav">
                <div class="container-fluid welcome-page" style="margin-top:0px;">
                    <div class="navbar-header col-sm-5 col-md-5 col-xs-12">

                        <!-- <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                            <span class="sr-only">Toggle navigation</span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button> -->
                        <a class="navbar-brand">
                            <img class="logo" src="assets/img/SG-logo-350px.png" style="top: -14px;" />
                        </a>
                    </div>
                    <div class=" navbar-collapse collapse col-sm-7 col-md-7 pull-right" id="navbar">
                        <a href="javascript:void(0);" class="closs">
                            <i class="icofont icofont-close-line"></i>
                        </a>
                    </div>
                </div>
            </nav>
        </header>
    </section>

    <div class="clearfix"></div>
    <br>

    <div class="login-bg loginWrap minhgt700" style="height: 100%">
        <!-- <div class="container">
            <div class="col-md-6 col-md-offset-3 mrgtp125">
                <div class="panel panel-default">
                    <div class="panel-body text-center">
                        <i class="fa fa-thumbs-up" style="font-size: 45px; color: #5ba55e"></i>
                        <h3>Loading..!</h3>
                        <br>
                        <h4>Please wait while we process your request</h4>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="browser-screen-loading-content onload-loader">
            <div class="loading-dots dark-gray">
              <i></i>
              <i></i>
              <i></i>
              <i></i>
            </div>
          </div>

    </div>

    <!-- <router-outlet></router-outlet> -->

    <section class="landingFooter">
        <div class="container">
            <div class="row text-center">
                <div class="col-md-6 copyright-block">
                    <p> {{currentYear}} StatementGames Inc. </p>
                </div>
                <div class="col-md-6 copyright-block">
                    <ul class="important-links">
                        <li *ngFor="let footer of footers" (click)="loadFooterContent(footer)">
                            <a href="javascript:void(0);">{{footer.title}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>